export default "/img/KG.227da8ae805b4d4c8e2c8e518b1d81ed.png";